import { fetchUsers } from '@/services/user';
import { UserDTO } from '@/models/user';

interface UserState {
  users: UserDTO[];
  usersLoading: boolean;
}

const initialState: UserState = {
  users: [],
  usersLoading: false
};

const getters = {
  users: (state: UserState): UserDTO[] => {
    return state.users;
  },
  usersLoading: (state: UserState): boolean => {
    return state.usersLoading;
  }
};

const mutations = {
  setUsers(state: UserState, users: UserDTO[]): void {
    state.users = users;
  },
  setUsersLoading(state: UserState, loading: boolean): void {
    state.usersLoading = loading;
  }
};

const actions = {
  async asyncFetchUsers({ commit }: any, projectId?: number): Promise<void> {
    commit('setUsersLoading', true);
    const userResponse = await fetchUsers(projectId);
    commit('setUsers', userResponse.data);
    commit('setUsersLoading', false);
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
};
